import { render, staticRenderFns } from "./TopicManager.vue?vue&type=template&id=69a14e14&scoped=true&"
import script from "./TopicManager.vue?vue&type=script&lang=js&"
export * from "./TopicManager.vue?vue&type=script&lang=js&"
import style0 from "./TopicManager.vue?vue&type=style&index=0&id=69a14e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a14e14",
  null
  
)

export default component.exports